const awsConfig = {
  GRAPHQL_API_URL: process.env.GRAPHQL_API_URL,
  GRAPHQL_API_KEY: process.env.GRAPHQL_API_KEY,
  POLLME_MAILER_URI: 'https://7xeofisqy8.execute-api.us-west-2.amazonaws.com/prod/mailer'
};

export default awsConfig;
